import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Grid, GridColumn } from 'telia-front-react/grid';
import { Chip } from 'telia-front-react/chip';
import { Button } from 'telia-front-react/button';
import { Text } from 'telia-front-react/text';
import { Card, CardContent, CardTop } from 'telia-front-react/card';
import TranslateStore from '@stores/TranslateStore';
import FilterStore from '@stores/FilterStore';
import { formatClockless } from '@util/DateUtil';

interface DisturbanceFilterBarProps {
    isDealer: boolean;
    customerId: number;
    filterStore?: FilterStore;
    translateStore?: TranslateStore;
}

class DisturbanceFilterBar extends React.Component<DisturbanceFilterBarProps> {
    public render(): React.ReactElement {
        const {
            translateStore: {translate},
            filterStore: {
                getClient, getCurrentStatus,
                startFrom, startUntil, selectedClientOnly, selectedInternalOnly, selectedElements,
                selectedAreas, selectedRegions, selectedStatuses, selectedCurrentStatus,
                toggleFilter, removeElement, resetStartFrom, resetStartUntil, removeInternal,
                removeClient, removeArea, removeStatus, removeRegion, resetCurrentStatus
            },
            customerId,
            isDealer,
        } = this.props;

        return (
            <Text>
                <Card padding={{ top: 'xsmall', bottom: 'xsmall', left: 'small', right: 'small' }}>
                    <CardContent>
                        <CardTop>
                            <Button text={translate('filter.filter')} iconLeft="#filter" type="text-color" link={true} isUnderlined={false} onClick={toggleFilter} />
                        </CardTop>
                    </CardContent>
                </Card>
                <Grid gutter="small">
                    {isDealer && customerId && selectedClientOnly && (
                        <GridColumn width={['xs']}>
                            <Chip onRemove={() => removeClient()}>{getClient.label}</Chip>
                        </GridColumn>
                    )}
                    {isDealer && selectedElements.map((element, key) => (
                        <GridColumn width={['xs']} key={key}>
                            <Chip onRemove={() => removeElement(element)}>{element}</Chip>
                        </GridColumn>
                    ))}
                    {isDealer && selectedInternalOnly.map((internal, key) => (
                      <GridColumn width={['xs']} key={key}>
                          <Chip onRemove={() => removeInternal(internal.id)}>{internal.children}</Chip>
                      </GridColumn>
                    ))}
                    {isDealer && selectedAreas.map((area, key) => (
                        <GridColumn width={['xs']} key={key}>
                            <Chip onRemove={() => removeArea(area.id)}>{area.children}</Chip>
                        </GridColumn>
                    ))}
                    {isDealer && selectedCurrentStatus && (
                      <GridColumn width={['xs']}>
                          <Chip onRemove={() => resetCurrentStatus(true)}>{getCurrentStatus.label}</Chip>
                      </GridColumn>
                    )}
                    {isDealer && selectedStatuses.map((status, key) => (
                        <GridColumn width={['xs']} key={key}>
                            <Chip onRemove={() => removeStatus(status.id)}>{status.children}</Chip>
                        </GridColumn>
                    ))}
                    {startFrom && (
                        <GridColumn width={['xs']}>
                            <Chip onRemove={() => resetStartFrom(true)}>{formatClockless(startFrom)}</Chip>
                        </GridColumn>
                    )}
                    {startUntil && (
                        <GridColumn width={['xs']}>
                            <Chip onRemove={() => resetStartUntil(true)}>{formatClockless(startUntil)}</Chip>
                        </GridColumn>
                    )}
                    {selectedRegions.map((region, key) => (
                        <GridColumn width={['xs']} key={key}>
                            <Chip onRemove={() => removeRegion(region.id)}>{region.children}</Chip>
                        </GridColumn>
                    ))}
                </Grid>
            </Text>
        );
    }
}

export default inject(
  'isDealer',
  'customerId',
  'filterStore',
  'translateStore',
)(observer(DisturbanceFilterBar));
